import React from "react";

export default () => {
    return <h1>404</h1>;
};
